namespace TabAurous.OMS {
    export namespace AdditionalChargesVouchersService {
        export const baseUrl = 'OMS/AdditionalChargesVouchers';

        export declare function Create(request: Serenity.SaveRequest<AdditionalChargesVouchersRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<AdditionalChargesVouchersRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<AdditionalChargesVouchersRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<AdditionalChargesVouchersRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "OMS/AdditionalChargesVouchers/Create",
            Update = "OMS/AdditionalChargesVouchers/Update",
            Delete = "OMS/AdditionalChargesVouchers/Delete",
            Retrieve = "OMS/AdditionalChargesVouchers/Retrieve",
            List = "OMS/AdditionalChargesVouchers/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>AdditionalChargesVouchersService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
